export enum EVerificationType {
  OUTGOING_CALL = 'OUTGOING_CALL',
  INCOMING_CALL = 'INCOMING_CALL',
  TELEGRAM = 'TELEGRAM',
  VK = 'VK',
  EMAIL = 'EMAIL',
}

export interface IRegisterRequest {
  input: {
    // first_name: string;
    nickname: string;
    dob: string;
    phone: string;
    password: string;
    confirm_password: string;
    email?: string;
    captcha_token: string;
    verification_type: EVerificationType | null;
    news_consent: boolean;
  };
}
export interface IRegisterResponse {
  register: {
    user: {
      id: number;
      uuid: string;
      phone: string;
    };
    verification: {
      success: boolean;
      verification_id: string;
      call_number: string;
    };
  };
}

export interface IStartVerificationRequest {
  input: {
    phone: string;
    email?: string;
    captcha_token?: string;
    type: EVerificationType;
  };
}

export interface IStartVerificationResponse {
  startVerification: {
    success: boolean;
    verification_id: string;
    call_number: string;
  };
}

export enum EVerificationStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  SENT = 'SENT',
  FAILED = 'FAILED',
  EXPIRED = 'EXPIRED',
}
export enum EVerificationClubStatus {
  UNVERIFIED = 'UNVERIFIED',
  REVIEW = 'REVIEW',
  VERIFIED = 'VERIFIED',
  DECLINED = 'DECLINED',
}

export interface IGetVerificationStatusResponse {
  getVerificationStatus: {
    status: EVerificationStatus;
  };
}

export interface IGetVerificationStatusRequest {
  verification_id: string;
}
